module.exports = __webpack_public_path__ + "img/rule-5-topper.e43839b2.png";